import * as actions from './redux/actions';

import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class PaymentSidebarBip extends Component {
	static propTypes = {
		home: PropTypes.object.isRequired,
		actions: PropTypes.object.isRequired,

		walletMoneyAdded: PropTypes.func,
		virtualMoneyAmount: PropTypes.func,
		basicFare: PropTypes.func,
		calculateNetFare: PropTypes.func,
		calculateNetFareUSD: PropTypes.func,
		promoCode: PropTypes.string,
		promoCouponAmount: PropTypes.number,
		t: PropTypes.func,
		showUsd: PropTypes.bool,
		lastRechargeAmount: PropTypes.string,
	};

	countrieCodes = [];
	paymentGatewayList;
	idCardTypes = [];

	constructor(props) {
		super(props);
		this.state = {
			mobileError: null,
			emailError: null,
			confirmEmailError: null,
			selectedPaymentGateway: null,
			showBookingConfirmModal: false,
			wallet: false,
			walletMoney: 0,
			confirmTabSelected: 1,
			selectSeatsOnward: [],
			selectSeatsReturn: [],
			journeyTypeActive: 1,
		};
	}

	componentWillMount() { }

	componentDidUpdate() { }

	seatTypesFrequeny(arr) {
		var a = [],
			b = [],
			prev = {};

		arr.sort((a, b) => {
			if (a.fare > b.fare) return 1;
			if (b.fare > a.fare) return -1;

			return 0;
		});
		for (var i = 0; i < arr.length; i++) {
			if (prev && arr[i].type !== prev.type) {
				a.push(arr[i]);
				b.push(1);
			} else {
				b[b.length - 1]++;
			}
			prev = arr[i];
		}

		return [a, b];
	}

	renderSummaryDetailsCard = (service, date, source, dest, title, duration) => {
		return (
			<div className="summary-details">
				<div className="op-name light-text font10">
					{this.props.t('PASSENGER_DETAILS.BIP_CARD_NUMBER')}
				</div>
				<div className="bip-side-amount-x bold-text font10">XXXXXXXX</div>
				<div className="bip-sub-amount-side">
					<div className="payment-seat-row flex-row font10">
						<div>{this.props.t('PASSENGER_DETAILS.LATEST_BALANCE')}</div>
						<div className="bold-text">CLP$ 2.000</div>
					</div>
				</div>
			</div>
		);
	};

	render() {
		const { t } = this.props;
		let date = DateService.getTodayString();

		console.log('props in bip side bar', this.props);

		return (
			<div className="pb-payment-details-payment-right-side-bar journey-summary-sidebar ">
				<div className="kupos-card">
					<div>
						<div className="summary-title font13">
							{this.props.t('PASSENGER_DETAILS.BIP_RECHARGE_DETAILS.NORMAL')}
							<span className="bold-text">
								{this.props.t('PASSENGER_DETAILS.BIP_RECHARGE_DETAILS.BOLD')}
							</span>
						</div>

						{/* {this.renderSummaryDetailsCard(
              '',
              date,
              'Santiago',
              'Arpt. Arturo Merino Benítez',
              'TRANSVIP',
              '90',
            )} */}

						<div className="summary-details">
							<div className="op-name light-text font10">
								{this.props.t('PASSENGER_DETAILS.BIP_CARD_NUMBER')}
							</div>
							<div className="bip-side-amount-x bold-text font10">
								{this.props.bipData && this.props.bipData.cardNumber}
							</div>
							<div className="bip-sub-amount-side">
								<div className="payment-seat-row flex-row font10">
									<div>{this.props.t('PASSENGER_DETAILS.LATEST_BALANCE')}</div>
									<div className="bold-text">
										CLP {CommonService.currency(this.props.lastRechargeAmount)}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="payment-details-sidebar">
						<div className="payment-seats">
							<div className="payment-seat-row flex-row font10">
								<div>{this.props.t('PASSENGER_DETAILS.RECHARGE_AMOUNT')}</div>
								<div
									className="bold-text"
									style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 82 }}
								>
									CLP {CommonService.currency(this.props.bipData && this.props.bipData.amount)}
								</div>
							</div>
						</div>
						<div className="discount-block fl ">
							<div className="discount-row flex-row">
								<div className="font10">{t('PASSENGER_DETAILS.DISCOUNT')}</div>
								<div
									className="secondary-text font10 bold-text "
									style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 82 }}
								>
									CLP $0
									{/* CLP{CommonService.currency(this.props.pbServiceList.bookingDetailsOnward.discountAmount).split(',')[0]} */}
								</div>
							</div>
							<div className="discount-row flex-row">
								<div className="font10">{t('PASSENGER_DETAILS.PROMO_CODE')}</div>
								<div
									className="secondary-text font10 bold-text "
									style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 82 }}
								>
									{/* CLP{CommonService.currency(this.props.promoCouponAmount ? this.props.promoCouponAmount : 0).split(',')[0]} */}
									CLP $0
								</div>
							</div>
							{this.props.promoCouponAmount ? (
								<div className="promocode font10">{this.props.promoCode}</div>
							) : null}
						</div>
						<div className="subtotal-block font10">
							{this.props.showUsd ? (
								<div className="subtotal-row flex-row">
									<div className="primary-text">{t('PASSENGER_DETAILS.AMOUNT_IN_USD')}</div>
									<div
										className="primary-text bold-text "
										style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 82 }}
									>
										USD
										{CommonService.currency(+this.props.calculateNetFareUSD()).split(',')[0]}
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
				<div className="total bold">
					<div className="total-row flex-row font13">
						<div>Total</div>
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							CLP {CommonService.currency(this.props.bipData && this.props.bipData.amount)}
						</div>
						{/* <div>CLP{CommonService.currency(+this.props.calculateNetFare()).split(',')[0]}</div> */}
					</div>
				</div>
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSidebarBip);



// WEBPACK FOOTER //
// ./src/features/home/PaymentSidebarBip.js